export const defaultPaymentDomainState = {
    paymentMethodsForQuery: {}
};
